import CoreModal from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal";
import { FormInputWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormInputWrapper";
import { FormSelectWrapper } from "@pages/SupplyChain/components/InventoryOverview/modals/CoreModal/FormSelectWrapper";
import React, { useEffect, useState } from "react";
import { SupplierEntity } from "../../entitys";
import styles from "../styles.module.scss";

interface SupplierModalProps {
  open: boolean;
  initial?: SupplierEntity | null;
  onClose: () => void;
  onSubmit: (data: SupplierEntity, mode: "add" | "edit") => void;
}

const emptyState: SupplierEntity = {
  name: "",
  supplierId: "",
  country: "UK",
  address: "",
  defaultMoq: "",
  defaultMsq: "",
  defaultLeadTime: "",
};

export const SupplierModal: React.FC<SupplierModalProps> = ({
  open,
  initial,
  onClose,
  onSubmit,
}) => {
  const [formData, setFormData] = useState<SupplierEntity>(emptyState);

  useEffect(() => {
    if (open && initial) setFormData(initial);
    if (open && !initial) setFormData(emptyState);
  }, [open, initial]);

  const handleChange = (val: string, name: keyof SupplierEntity) =>
    setFormData((s) => ({ ...s, [name]: val }));

  const handleOk = () => {
    onSubmit(formData, initial ? "edit" : "add");
  };

  const isValid =
    formData.name.trim() !== "" &&
    formData.supplierId.trim() !== "" &&
    formData.country.trim() !== "" &&
    formData.defaultLeadTime !== "";

  return (
    <CoreModal
      open={open}
      title={initial ? "Edit Supplier" : "Add Supplier"}
      onCancel={onClose}
      onSave={handleOk}
      disabledButton={!isValid}
    >
      <FormInputWrapper
        label="name"
        placeholder="Supplier Name"
        value={formData.name}
        onChange={(v) => handleChange(v, "name")}
        className={styles.input}
      />

      <div className={styles.row}>
        <FormSelectWrapper
          label="Supplier id"
          placeholder="Select id"
          value={formData.supplierId}
          onChange={(v) => handleChange(v, "supplierId")}
          options={[
            { id: "7894", text: "7894" },
            { id: "78234", text: "78234" },
            { id: "7123894", text: "7123894" },
          ]}
        />

        <FormSelectWrapper
          label="country"
          placeholder="Select country"
          value={formData.country}
          onChange={(v) => handleChange(v, "country")}
          options={[
            { id: "UK", text: "UK" },
            { id: "EN", text: "EN" },
            { id: "USA", text: "USA" },
          ]}
        />
      </div>

      <FormInputWrapper
        label="Address"
        optional
        placeholder="Killarney Lane St. 8/1, London"
        value={formData.address}
        onChange={(v) => handleChange(v, "address")}
      />

      <div className={styles.row}>
        <FormInputWrapper
          label="Default MOQ"
          optional
          placeholder="350"
          value={formData.defaultMoq}
          onChange={(v) => handleChange(v, "defaultMoq")}
          type="number"
          tooltipTitle="Default Minimum Order Quantity"
        />

        <FormInputWrapper
          label="Default MSQ"
          optional
          placeholder="26"
          value={formData.defaultMsq}
          onChange={(v) => handleChange(v, "defaultMsq")}
          type="number"
          tooltipTitle="Default Minimum Shipment Quantity"
        />
      </div>

      <FormInputWrapper
        label="Default Lead time"
        optionalText="(days)"
        optional
        placeholder="14"
        value={formData.defaultLeadTime}
        onChange={(v) => handleChange(v, "defaultLeadTime")}
        type="number"
        tooltipTitle="Default Production Time"
      />
    </CoreModal>
  );
};

export default SupplierModal;
